import { render, staticRenderFns } from "./GroupStat.vue?vue&type=template&id=de793ecc"
import script from "./GroupStat.vue?vue&type=script&lang=js"
export * from "./GroupStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports